import { ReactElement, useImperativeHandle, useState } from 'react';
import { PlayerState, YoutubeVideoProps } from './index';
import YoutubeVideoPoster from './YoutubeVideoPoster';
import classNames from 'classnames';
import ReactPlayer from 'react-player/lazy';

const componentName = 'youtube-video';

/**
 * Displays a Youtube video with preview image and badge.
 */
function YoutubeVideo({
    className,
    videoUrl,
    previewImageAlt,
    previewImageUrl,
    videoRef,
}: YoutubeVideoProps): ReactElement {
    const [showIframe, setShowIframe] = useState(false);
    const [playing, setPlaying] = useState(false);
    const [showPlayButton, setShowPlayButton] = useState(true);

    const handlePlay = () => setPlaying(true);
    const handlePause = () => setPlaying(false);
    const onPlayButtonClick = () => {
        handlePlay();
        setShowPlayButton(false);
    };

    useImperativeHandle(videoRef, () => ({
        getPlayerState: () => (playing ? PlayerState.PLAYING : PlayerState.PAUSED),
        pauseVideo: () => setPlaying(false),
    }));

    return (
        <div className={classNames(componentName, className)} onClick={() => setShowIframe(true)}>
            <YoutubeVideoPoster
                showPreview={!showIframe && Boolean(previewImageUrl)}
                previewImageUrl={previewImageUrl ?? ''}
                previewImageAlt={previewImageAlt ?? ''}
            />
            {(showIframe || !previewImageUrl) && (
                <>
                    <ReactPlayer
                        playing={playing}
                        width="100%"
                        height="100%"
                        muted
                        controls
                        url={videoUrl}
                        playsinline
                        onPlay={handlePlay}
                        onPause={handlePause}
                        onEnded={handlePause}
                    />
                    {showPlayButton && (
                        <button
                            className={`${componentName}__overlay-button`}
                            type="button"
                            onClick={onPlayButtonClick}
                            title="play"
                        />
                    )}
                </>
            )}
        </div>
    );
}
export default YoutubeVideo;
